import {Injectable, OnInit} from '@angular/core';
import {Http} from '@angular/http';
import {HttpClient, HttpHeaders} from '../../node_modules/@angular/common/http';
import {environment} from '../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CamundaService implements OnInit {
    pKeyHeader: any;
    adminPKeyHeader: any;
    httpOptions: any;
    httpOptionsOfThirdParty: any;
    // camundaHttpOptions: any;
    appclientHttpOptions: any;
    billingHttpOptions: any;
    templatesHttpOptions: any;
    commonsHttpOptions: any;
    AWSOptions: any;
    file: any;
    captchaOptions: any;
    linkzyOptions: any;
    adminHttpOptions: any;
    camundaHttpOptions: any;

    constructor(private _http: HttpClient, private http: Http) {
    }

    ngOnInit() {

    }

    getHttp() {

        this.pKeyHeader = new HttpHeaders({'pkey': localStorage.getItem('partnerKey')});
        this.adminPKeyHeader = new HttpHeaders({'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc'});

        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.camundaHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + btoa('demo:demo')
            })
        };
        this.adminHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.httpOptionsOfThirdParty = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd7244d02a830763fcddf5c572a5b54',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        // this.camundaHttpOptions = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'multipart/form-data',
        //         'authorization': 'Basic cHJhc2FubmE6cHJhc2FubmE=',
        //     })
        // };

        this.appclientHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
                'x-api-key': 'wdwffgefg4122455asdadfvf',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.billingHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.templatesHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe41b41ed1b380a3fef0342c76a973b',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.commonsHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe18f9884ea832e3fede1e661740c4a',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.AWSOptions = {

            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-api-key': 'DBnsIEzlsP7uqEA3C1bjn2ael5BtYRH2atjDA1A3'
            })
        };

        this.captchaOptions = {

            headers: new HttpHeaders({
                'apikey': 'VbTqJFL35SCseJlHfF3Vqc31LmkSxsAK',
                'pkey': '3fe408b3a9da46563fecb834832ef39d',
                // 'Content-Type': 'application/json',
                // 'pkey': '3fe408b3a9da46563fecb834832ef39d',
                // 'Access-Control-Allow-Origin': '*',
                // 'observe': 'response'

            })
        };
        this.linkzyOptions = {

            headers: new HttpHeaders({
                'apikey': 'DPsm13YUiwG7ied906pmR2qWNCJCvrHY',
                'pkey': '3fdfb5476cd996603febe74f67d39715',
                // 'Content-Type': 'application/json',
                // 'pkey': '3fe408b3a9da46563fecb834832ef39d',
                // 'Access-Control-Allow-Origin': '*',
                // 'observe': 'response'

            })
        };
    }

    ///

//     this.getHttp();
//     const formData = new FormData();
//     formData.append('multipartFile', image);
//     const httpOptions = {
//         headers: new HttpHeaders({
//             'pkey': localStorage.getItem('partnerKey'),
//         })
//     };
//     return this._http.post(environment.apihost + '/v1/data/' + partner + '/upload?' + (fileName ? 'fileName=' + fileName : '') + '&' +
// (folder ? 'folder=' + folder : ''), formData, httpOptions).pipe(map((resp) => resp.toString()));


    ///
    startProcessExecution(partner, account, processId, variables) {
        this.getHttp();
        return this._http.post(environment.camundaServer + '/process-definition/' + processId + '/start', variables, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getProcessInstances(partner, account, definitionId) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/process-instance/?processDefinitionId=' + definitionId, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getProcessVariables(partner, account, processInstanceId) {
        // https://camunda.apiplatform.io/engine-rest/history/variable-instance?processInstanceId=8e48a8ed-8b12-11ea-94a2-0e3b4f4b10a3&deserializeValues=false
        this.getHttp();
        return this._http.get(environment.camundaServer + '/history/variable-instance?processInstanceId=' + processInstanceId + '&deserializeValues=false', this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getTaskFormVariables(taskId, params) {
        let url = environment.camundaServer + '/task/' + taskId + '/form-variables';
        if (params && params !== '') {
            url += '?' + params;
        }
        return this._http.get(url).pipe(map(res => res));
    }

    getProcessId(partner, account, id) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/process-definition?deploymentId=' + id, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getProcessDefinitionWithKey(key) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/process-definition?key=' + key, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getUserTasksInProcessInstance(id) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/task?processInstanceId=' + id, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getWorkflowTasks(params) {
        let url = environment.camundaServer + '/task';
        if (params && params !== '') {
            url += '?' + params;
        }

        return this._http.get(url).pipe(map(res => res));
    }

    getVariablesForTask(id) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/task/' + id + '/form-variables', this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getRenderedForm(id) {
        this.getHttp();
        return this._http.get(environment.camundaServer + '/task/' + id + '/rendered-form', this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    completeUserTask(id, payload) {
        this.getHttp();
        return this._http.post(environment.camundaServer + '/task/' + id + '/complete', payload, this.camundaHttpOptions)
            .pipe(map(res => res));
    }

    getBPMNImage(partner, processId, id) {
        // let formData = new FormData();
        // formData.append('deployment-name', 'from angular');
        // formData.append('enable-duplicate-filtering', 'false');
        // formData.append('deployment-source', 'process application3');
        // formData.append('*', file);
        this.getHttp();

        // // const data = JSON.stringify({"asd":"asd"});
        // // return this.http.post('https://camunda.apiplatform.io/engine-rest/deployment/create', data, this.camundaHttpOptions).pipe(map(res=>res))
        // this.getHttp();
        // return this._http.post('https://camunda.apiplatform.io/engine-rest/deployment/create', formData, this.camundaHttpOptions)
        //     .pipe(map(res => res));
        // const camundaOptions = {
        //     headers: new HttpHeaders({
        //         'Content-Type': 'application/json',
        //         'Authorization': 'Basic ' + btoa('demo:demo')
        //     })
        // };
        return this._http.get(environment.camundaServer + '/process-definition/' + id + '/diagram' + processId + '/start', this.camundaHttpOptions)
            .pipe(map(res => res));

    }


    // insertPartner(data) {
    //     this.getHttp();
    //     return this._http.post(environment.apihost + '/v1/admin/partners', JSON.stringify(data), this.adminHttpOptions)
    //         .pipe(map(res => res));
    // }

}
